import React from "react";

const NmsWidget = ({ title, count, extra, children, className = "" }) => (
  <section className={`nms-widget ${className}`}>
    <header className="nms-widget-header">
      <div className="nms-widget-title">
        <span className="nms-drag-grip" aria-hidden="true" />
        <h3>{title}</h3>
        {count != null && <span className="nms-widget-count">{count}</span>}
      </div>
      {extra && <div className="nms-widget-extra">{extra}</div>}
    </header>
    <div className="nms-widget-body">{children}</div>
  </section>
);

export default NmsWidget;
